var map = {
	"./arrow-circle.svg": 1507,
	"./arrow-down.svg": 1508,
	"./arrow-up.svg": 1509,
	"./caret.svg": 1510,
	"./check-circle.svg": 1511,
	"./check.svg": 1512,
	"./currency-swaps.svg": 1513,
	"./exchange.svg": 1514,
	"./feature-fair-rates.svg": 1515,
	"./feature-licensed.svg": 1516,
	"./feature-safe.svg": 1517,
	"./illustration-charts-in-hand.svg": 1518,
	"./illustration-contract-hand-shake.svg": 1519,
	"./illustration-global-money.svg": 1520,
	"./illustration-licensed-platform.svg": 1521,
	"./illustration-money-withdraw.svg": 1522,
	"./illustration-wall-safe-deposit.svg": 1523,
	"./illustration-world-pins.svg": 1524,
	"./info.svg": 1525,
	"./language.svg": 1526,
	"./login.svg": 1527,
	"./logo.svg": 1528,
	"./safari-pinned-tab.svg": 1036,
	"./secure-workflow.svg": 1529,
	"./swap.svg": 1530,
	"./trust-authenticity.svg": 1531
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1543;



//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg ^\.\/.*\.svg$
// module id = 1543
// module chunks = 0